export default __webpack_public_path__ + "static/media/nineteen.a612d265.jpg";